import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import type { Promotion } from "~/types/promotion";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getPriceWithPromotion(
  startRate: number,
  promotions: Promotion[],
): { totalPrice: number; hasPromotion: boolean; originalPrice: number } {
  if (promotions && promotions.length > 0) {
    const promoAmount = promotions[0].discount;
    if (promotions[0].discount_type === "percentage") {
      const discountedPrice = startRate - (startRate * promoAmount) / 100;
      return {
        totalPrice: discountedPrice,
        hasPromotion: true,
        originalPrice: startRate,
      };
    }

    return {
      totalPrice: promoAmount,
      hasPromotion: true,
      originalPrice: startRate,
    };
  }

  return {
    totalPrice: startRate,
    hasPromotion: false,
    originalPrice: startRate,
  };
}
